import React, { useEffect, useRef, useState } from 'react'
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { getCategoryListingPaginate, getManufacturesListing, getManufacturesListingPaginate, getStoresListing, getSubCategoryDetails, getSubCategoryListingPaginate, updateManufacturer } from '../../api/context/manufacturer'
import toast from 'react-hot-toast'
import * as yup from 'yup';
import { useFormik } from 'formik';
import { IoMdArrowBack, IoMdCloseCircleOutline } from 'react-icons/io'
import { getCategoryListing } from '../../api/context/category'
import { getSubCategoryListing } from '../../api/context/subcategory'
import { BiPlus } from "react-icons/bi";
import upload from '../../assets/images/Paper Upload.png'
import Select from 'react-select'
import { createProducts, deleteProductImage, getProductsDetails, updateProducts } from '../../api/context/products';
import imageToBase64 from 'image-to-base64/browser';
import { SketchPicker } from 'react-color';
import AsyncSelect from 'react-select/async';
import { IoClose } from 'react-icons/io5';
import { MdDeleteOutline } from "react-icons/md";
import * as Yup from 'yup';
import { getBrandListing } from '../../api/context/brand';
import CircularProgress from '@mui/material/CircularProgress';
import { errorSelector } from 'recoil';
import Loader from '../../components/loader/loader';
import { FiPlus, FiUploadCloud } from 'react-icons/fi';


const CreateInventory = () => {


    const navigate = useNavigate()
    const colorPickerRef = useRef();

    const { state } = useLocation();

    const variantedit = state?.type;

    const { id } = useParams()

    const user = JSON.parse(localStorage.getItem('user'));

    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [update, setUpdate] = useState(false);
    const [store, setStore] = useState([]);
    const [category, setCategory] = useState([]);
    const [subcategory, setSubCategory] = useState([]);
    const [subsubcategory, setSubSubCategory] = useState([]);
    const [specificationDrpdwn, setSpecificationDrpDwn] = useState([]);
    const [manufacturers, setManufacturers] = useState([]);
    const [brands, setBrands] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [oldImages, setOldImages] = useState([]);
    const [oldVariantImages, setOldVariantImages] = useState([]);
    const [colorPickerVisible, setColorPickerVisible] = useState(false);
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedColorVariant, setSelectedColorVariant] = useState('');
    const [showSpecification, setShowSpecification] = useState(false)
    const [showVariantSpecification, setShowVariantSpecification] = useState(false)
    const [specicTypes, setSpecificTypes] = useState([])
    const [specificChange, setSpecificChange] = useState()
    const [variantspecificChange, setVariantSpecificChange] = useState()

    const [page, setPage] = useState(1); // Current page for API pagination
    const [hasMore, setHasMore] = useState(true); // To track if more data is available

    const [pagemanufacture, setPageManufacture] = useState(1);
    const [hasMoreManufacture, setHasMoreManufacture] = useState(true);

    const [thumbnailIndex, setThumbnailIndex] = useState(0);
    const [isOldImageThumbnail, setIsOldImageThumbnail] = useState(true);
    const [thumbnailImageUrl, setThumbnailImageUrl] = useState('');

    const [tags, setTags] = useState([]);

    const handleThumbnailSelect = (index, isOldImage = false) => {
        setThumbnailIndex(index);
        setIsOldImageThumbnail(isOldImage);

        if (isOldImage && oldImages[index]) {

            console.log("Old image selected for thumbnail:", oldImages[index]);
            // Store backend value in formik
            const s3Key = getS3KeyFromUrl(oldImages[index].imageUrl);
            formik.setFieldValue("thumbnailImageUrl", s3Key);
            console.log("S3 Key set in formik:", s3Key);

            // Store preview URL separately
            setThumbnailImageUrl(oldImages[index].imageUrl);
            console.log("Thumbnail preview URL set to old image URL:", oldImages[index].imageUrl);
        } else if (!isOldImage && formik.values.images[index]) {
            const img = formik.values.images[index];

            // Store backend value in formik
            formik.setFieldValue("thumbnailImageUrl", img);

            // Store preview URL separately
            const previewUrl = typeof img === "string" ? img : URL.createObjectURL(img);
            setThumbnailImageUrl(previewUrl);
        }
    };




    const handleShow = () => setShow(true);
    const handleSpecification = () => setShowSpecification(true)

    const handleVariantSpecification = () => {
        setShowVariantSpecification(true)
        setShow(false)
    }


    const handleClose = () => {
        setShowSpecification(false)
        setShow(false);
        variantformik.resetForm({
            values: {
                variantName: '',
                variantColor: '',
                variantPrice: '',
                variantDiscountedPrice: '',
                variantStock: '',
                specs: [{ name: '', value: '' }],
                variantImages: [],
                variantSizes: [
                    {
                        sizes: [{ size: '', stock: '' }]
                    }
                ],
            },
        });
    };

    const handleSpecificationClose = () => {
        setShowVariantSpecification(false)
        setShow(true)
    };

    const cancelStore = () => {
        navigate(-1)
    }


    const handleImageChange = async (e) => {
        const files = Array.from(e?.target?.files);

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

        }

        const images = await Promise.all(
            files.map(async (file) => {


                try {
                    const response = await imageToBase64(URL.createObjectURL(file));
                    return `data:image/jpeg;base64,${response}`;
                } catch (error) {
                    return null;
                }
            })
        );

        formik.setValues({
            ...formik.values,
            images: [...(formik.values.images || []), ...images], // Ensure images is an array
        });

        e.target.value = null;
    }

    const handleImageVariantChange = async (e) => {
        const files = Array.from(e?.target?.files);


        const images = await Promise.all(
            files.map(async (file) => {
                try {
                    const response = await imageToBase64(URL.createObjectURL(file));
                    return `data:image/jpeg;base64,${response}`;
                } catch (error) {
                    return null;
                }
            })
        );

        variantformik.setValues({
            ...variantformik.values,
            variantImages: [...(variantformik.values.variantImages || []), ...images],
        });
        e.target.value = null;
    }




    const validationSchema = yup.object().shape({

        productName: yup
            .string()
            .matches(/^(?!\s*$)[^\s].*$/, 'Product name cannot be blank or contain only spaces')
            .required('Product name is required'),
        subCategoryId: yup
            .string('')
            .required('Category is required'),
        subSubCategoryId: yup
            .string('')
            .required('Sub category is required'),
        manufacturerId: user?.userType !== "Vendor"
            ? yup.string().required('Required')
            : yup.string(),
        description: yup
            .string('')
            .required('Description is required'),
        color: yup
            .string('')
            .required('Color is required'),
        stock: yup
            .string('')
            .matches(/^[0-9]+$/, 'Enter a valid stock')
            .required('Stock is required'),
        images: id ? yup.array() : yup.array().min(1).required("Required"),


        price: yup
            .string()
            .required('Price is required'),
        discountedPrice: yup
            .string()
            .test(
                'is-less-than-price',
                'Discounted price must be less than price',
                function (value) {
                    const price = this.parent.price;
                    if (!price || !value) return true; // Skip validation if either field is empty
                    return parseFloat(value) <= parseFloat(price);
                }
            ),

        sizes: yup
            .array()
            .of(
                yup.object().shape({
                    size: yup.string().required('Size is required'),
                    stock: yup
                        .string()
                        .matches(/^[0-9]+$/, 'Enter a valid stock')
                        .required('Stock is required'),
                })
            )
            .min(1, 'At least one size must be added')
            .required('Sizes are required'),
        thumbnailImageUrl: yup.string(),


    });

    const formik = useFormik({
        initialValues: {
            subCategoryId: '',
            selectedCategory: '',
            subSubCategoryId: '',
            selectedSubCategory: '',
            manufacturerId: '',
            selectedManufacture: '',
            brandId: '',
            selectedBrand: '',
            productName: '',
            description: '',
            isProductVariant: false,
            stock: '',
            color: '',
            price: '',
            discountedPrice: '',
            sizes: [],
            specs: [
                { name: '', value: '' }
            ],
            images: [],
            variants: [],
            tags: [],
            thumbnailImageUrl: '',
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {};

            if (!values.selectedCategory) {
                errors.selectedCategory = "Category is required";
            }
            if (!values.selectedSubCategory) {
                errors.selectedSubCategory = "Sub category is required";
            }
            if (user?.userType !== "Vendor") {
                if (!values.selectedManufacture) {
                    errors.selectedManufacture = "Vendor is required";
                }
            }
            if (!values.selectedBrand) {
                errors.selectedBrand = "Brand is required";
            }

            // ✅ Sizes validation
            const filledSizes = values.sizes.filter(
                (s) => s.size?.trim() !== '' || s.stock?.trim() !== ''
            );

            if (filledSizes.length === 0) {

            }

            return errors;
        },

        onSubmit: async (values, { resetForm }) => {

            console.log("Formik onSubmit called", values);

            setLoading(true);

            values.manufacturerId = user?.vendorId ? user?.vendorId : values.manufacturerId;

            try {
                if (id) {

                    updateProducts(values)((response) => {
                        if (response && response?.data?.statusCode == 200) {
                            setLoading(false);
                            resetForm();
                            toast.success("Product Updated Successfully")
                            navigate(-1);
                        } else {
                            setLoading(false);
                            toast.error(response?.data?.message);

                        }
                    })

                }
                else {

                    createProducts(values)((response) => {

                        if (response && response?.data?.statusCode == 200) {
                            setLoading(false);
                            resetForm();
                            toast.success("Product Created Successfully")
                            navigate(-1);
                        } else {

                            setLoading(false);
                            toast.error(response?.data?.message);

                        }
                    })
                }
            } catch (error) {
                setLoading(false);
            }
        },

    });

    const variantformik = useFormik({
        initialValues: {
            variantName: '',
            variantColor: '',
            variantPrice: '',
            variantDiscountedPrice: '',
            variantStock: '',
            // specs: [],
            specs: [
                { name: '', value: '' }
            ],
            variantImages: [],
            variantSizes: [
                {
                    sizes: [
                        { size: '', stock: '' }
                    ]
                }
            ],

        },
        validationSchema: Yup.object().shape({
            variantName: Yup.string().required('Required'),
            variantColor: Yup.string().required('Required'),
            variantStock: Yup.string().required('Required'),
            variantPrice: Yup.string().required('Required'),
            variantImages: id ? yup.array() : yup.array().min(1).required("Required"),
            variantSizes: yup
                .array()
                .of(
                    yup.object().shape({
                        sizes: yup
                            .array()
                            .of(
                                yup.object().shape({
                                    size: yup.string().required('Size is required'),
                                    stock: yup
                                        .string()
                                        .matches(/^[0-9]+$/, 'Enter a valid stock')
                                        .required('Stock is required'),
                                })
                            )
                            .min(1, 'At least one size must be added')
                            .required('Sizes are required'),
                    })
                )
                .min(1, 'At least one variant size group is required')
                .required('Variant sizes are required'),


        }),
        // validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            setLoading(true);
            addVariant(values);
        },

    });


    const addVariant = (variantValues) => {

        let variant = formik.values.variants;
        variant.push(variantValues)

        formik.setValues({
            ...formik.values,
            variants: variant,
        });
        handleClose();
        setLoading(false);
        variantformik.resetForm({
            values: {
                variantName: '',
                variantColor: '',
                variantPrice: '',
                variantDiscountedPrice: '',
                variantStock: '',
                specs: [{ name: '', value: '' }],
                variantImages: [],
                variantSizes: [
                    {
                        sizes: [{ size: '', stock: '' }]
                    }
                ],
            },
        });
    };



    const handleAddSize = () => {
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Add a new size and stock object to the sizes array
        updatedVariantSizes[0].sizes.push({ size: '', stock: '' });

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);
    };

    const handleVariantSpecificationAdd = () => {
        const updatedVariantSpecifications = [...variantformik.values.specs];

        updatedVariantSpecifications.push({ name: '' });

        variantformik.setFieldValue('specs', updatedVariantSpecifications);
    };

    const handleSizeSelectChange = (index, selectedOption) => {
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Update the size value inside the sizes array of the current variantSizes object
        updatedVariantSizes[0].sizes[index] = {
            ...updatedVariantSizes[0].sizes[index],
            size: selectedOption ? selectedOption.label : ''  // Set the selected size value
        };

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);
    };

    const calculateTotalStock = () => {
        const total = variantformik.values.variantSizes[0].sizes.reduce((sum, item) => {
            const stockValue = parseInt(item.stock, 10) || 0; // Parse the stock value
            return sum + stockValue;
        }, 0);
        return total;
    };

    const handleSizeStockChange = (index, e) => {
        const { name, value } = e.target;
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Update the size or stock value inside the sizes array of the current variantSizes object
        updatedVariantSizes[0].sizes[index] = {
            ...updatedVariantSizes[0].sizes[index],
            [name]: value // Either 'size' or 'stock'
        };

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);

        // Calculate and update total stock
        const totalStock = calculateTotalStock();
        variantformik.setFieldValue('variantStock', totalStock); // Make sure to manage totalStock in your formik state
    };

    const handleDeleteSizeStock = (index) => {
        const updatedVariantSizes = [...variantformik.values.variantSizes];

        // Remove the selected size
        updatedVariantSizes[0].sizes.splice(index, 1);

        variantformik.setFieldValue('variantSizes', updatedVariantSizes);

        // Recalculate total stock after deletion
        const totalStock = calculateTotalStock();
        variantformik.setFieldValue('variantStock', totalStock); // Update total stock in formik state
    };


    const handleSizeCheckboxChange = (sizeLabel, checked) => {
        let newSizes;

        if (checked) {
            newSizes = [...formik.values.sizes, { size: sizeLabel, stock: 0 }];
        } else {
            newSizes = formik.values.sizes.filter(s => s.size !== sizeLabel);
        }

        // Update sizes
        formik.setFieldValue('sizes', newSizes);

        // Update total stock
        const totalStock = newSizes.reduce((sum, s) => sum + (parseInt(s.stock) || 0), 0);
        formik.setFieldValue('stock', totalStock);
    };

    const handleProductSizeStockChangeByName = (sizeLabel, e) => {
        const value = e.target.value;

        const newSizes = formik.values.sizes.map(s =>
            s.size === sizeLabel ? { ...s, stock: value } : s
        );

        // Update sizes
        formik.setFieldValue('sizes', newSizes);

        // Update total stock
        const totalStock = newSizes.reduce((sum, s) => sum + (parseInt(s.stock) || 0), 0);
        formik.setFieldValue('stock', totalStock);
    };




    const handleSpecificationAdd = () => {
        const updatedProductSpecifications = [...formik.values.specs];

        updatedProductSpecifications.push({ name: '' });

        formik.setFieldValue('specs', updatedProductSpecifications);
    };

    const calculateTotalSizeStock = () => {
        return formik.values.sizes.reduce((total, item) => {
            return total + (parseInt(item.stock) || 0); // Convert stock to a number and add it to the total
        }, 0);
    };

    const handleProductSizeStockChange = (index, event) => {
        const { value } = event.target;

        // Update stock for the selected size
        const updatedSizes = [...formik.values.sizes];
        updatedSizes[index].stock = value;

        formik.setFieldValue('sizes', updatedSizes);

        // Calculate the new total size stock and set it in the stock field
        const totalStock = calculateTotalSizeStock();
        formik.setFieldValue('stock', totalStock);
    };


    const handleDeleteProductSizeStock = (index) => {
        // Create a copy of sizes
        const updatedSizes = [...formik.values.sizes];

        // Remove the selected item
        updatedSizes.splice(index, 1);

        // Recalculate total stock
        const totalStock = updatedSizes.reduce((sum, item) => sum + (parseInt(item.stock) || 0), 0);

        // Update Formik state
        formik.setValues({
            ...formik.values,
            sizes: updatedSizes,
            stock: totalStock, // Update total stock
        });
    };

    const handleProductSizeChange = (index, selectedOption) => {
        const updatedSizes = [...formik.values.sizes];
        updatedSizes[index].size = selectedOption ? selectedOption.label : ''; // Update size with selected value
        formik.setFieldValue('sizes', updatedSizes); // Update the sizes array in formik
    };

    const handleProductSpecificationChange = (index, selectedOption) => {
        const updatedSpecifications = [...formik.values.specs];
        updatedSpecifications[index].name = selectedOption ? selectedOption.label : '';
        formik.setFieldValue('specs', updatedSpecifications);
    };


    const handleVariantSpecificationChange = (index, selectedOption) => {
        const updatedVariantSpecifications = [...variantformik.values.specs];
        updatedVariantSpecifications[index].name = selectedOption ? selectedOption.label : ''; // Update size with selected value
        variantformik.setFieldValue('specs', updatedVariantSpecifications); // Update the sizes array in formik
    };

    const getS3KeyFromUrl = (url) => {
        if (!url) return '';

        try {
            // Handle already being an S3 key (no http://)
            if (!url.startsWith('http')) {
                return url; // Already an S3 key
            }

            // Extract the path before query parameters
            const urlWithoutParams = url.split('?')[0];

            // Extract the path after the domain
            const urlObj = new URL(urlWithoutParams);
            const pathname = urlObj.pathname;

            // Remove leading slash and decode URL encoding
            const decodedPath = decodeURIComponent(pathname.substring(1));

            return decodedPath;
        } catch (error) {
            console.error('Error parsing URL:', error);
            return '';
        }
    };



    let typingTimer;

    const loadOptionsCategory = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 2) {
                    getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        if (response?.statusCode == 200) {
                            resolve(response?.results);
                            setCategory(response?.results)
                        } else {
                        }
                    })
                }
                else {
                    resolve([]);
                    setCategory([])
                    setSubCategory([])
                }

            }, 300);
        });
    };

    const loadOptionsSubCategory = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                const categoryId = formik?.values?.subCategoryId;
                if (inputValue.length >= 2 && categoryId) {
                    getSubCategoryListingPaginate({ page: 1, pageSize: 10, search: inputValue, categoryIds: [categoryId] })(response => {
                        if (response?.statusCode == 200) {
                            resolve(response?.results);
                            setSubCategory(response?.results)
                        } else {
                        }
                    })
                }
                else {
                    resolve([]);
                    setSubCategory([])
                }

            }, 300);
        });
    };


    useEffect(() => {
        getBrandListing({ vendorId: user?.vendorId ?? formik?.values?.manufacturerId, page: 1, pageSize: 10, search: '' })(response => {
            if (response?.statusCode == 200) {
                setBrands(response?.data?.map((item, index) => {
                    return {
                        value: item.id,
                        label: item.name
                    }

                }))
            }
        })
    }, [manufacturers, formik.values.manufacturerId])

    const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
        return new Promise((resolve) => {
            clearTimeout(typingTimer); // Clear previous debounce timer
            typingTimer = setTimeout(() => {
                getBrandListing({ vendorId: user?.vendorId ?? formik.values.manufacturerId, page: currentPage, pageSize: limit, search: inputValue })(response => {
                    if (response?.statusCode === 200) {

                        const results = response?.data?.map(item => ({
                            value: item.id,
                            label: item.name,
                        }));

                        if (currentPage === 1) {
                            setBrands(results); // Reset for a new search
                        } else {
                            setBrands((prevBrands) => [...prevBrands, ...results]); // Append for pagination
                        }

                        setHasMore(results.length > 0); // Update hasMore based on fetched data
                        resolve(results);
                    } else {
                        setHasMore(false); // No more data
                        resolve([]);
                    }
                });
            }, 300); // Debounce interval
        });
    };

    const loadOptionsBrands = (inputValue) => {
        return fetchBrands(inputValue, 1); // Always fetch the first page for a new search
    };

    const handleMenuScrollToBottom = () => {
        if (hasMore) {
            const nextPage = page + 1;
            fetchBrands(formik.values.selectedBrand?.label || '', nextPage).then(() => {
                setPage(nextPage); // Increment page after fetching
            });
        }
    };

    const fetchManufacturers = (inputValue, currentPage = 1, limit = 10) => {
        return new Promise((resolve) => {
            clearTimeout(typingTimer); // Clear previous debounce timer
            typingTimer = setTimeout(() => {
                getManufacturesListingPaginate({ page: currentPage, limit, search: inputValue })(response => {
                    if (response?.statusCode === 200) {
                        const results = response?.results?.map(item => ({
                            value: item.value,
                            label: item.label,
                        }));

                        if (currentPage === 1) {
                            setManufacturers(results); // Reset manufacturers for a new search
                        } else {
                            setManufacturers((prevManufacturers) => [...prevManufacturers, ...results]); // Append for pagination
                        }

                        setHasMoreManufacture(results.length > 0); // Update `hasMore` based on fetched data
                        resolve(results); // Resolve results to AsyncSelect
                    } else {
                        setHasMoreManufacture(false); // No more data
                        resolve([]); // Resolve with an empty array
                    }
                });
            }, 300); // Debounce interval
        });
    };

    const loadOptionsManufacture = (inputValue) => {
        return fetchManufacturers(inputValue, 1); // Fetch the first page for a new search
    };

    const handleMenuScrollToBottomManufacture = () => {
        if (hasMoreManufacture) {
            const nextPage = pagemanufacture + 1;
            fetchManufacturers(formik.values.selectedManufacture?.label || '', nextPage).then(() => {
                setPageManufacture(nextPage); // Increment page after fetching
            });
        }
    };

    const onBrandChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            brandId: selectedOption ? selectedOption.value : '',
            selectedBrand: selectedOption,
        });
    };


    const onManufactureChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            manufacturerId: selectedOption ? selectedOption.value : '',
            selectedManufacture: selectedOption,
            selectedBrand: '',
            brandId: '',
        });
    };

    const onCategoryChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            subCategoryId: selectedOption ? selectedOption.value : '',
            selectedCategory: selectedOption,
            subSubCategoryId: '',           // Reset subcategory
            selectedSubCategory: '',        // Reset subcategory select
            sizes: [], // Reset sizes to initial state
            stock: '',                      // Optionally reset stock as well
        });
        setSubCategory([]); // Optionally clear subcategory options
        setSubSubCategory([]); // Optionally clear sizes options
    };

    const onSubCategoryChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            subSubCategoryId: selectedOption ? selectedOption.value : '',
            selectedSubCategory: selectedOption,
        });
    };

    let parentTimer;
    const loadSizesData = (inputValue) => {
        return new Promise((resolve, reject) => {
            clearTimeout(parentTimer);
            parentTimer = setTimeout(() => {
                if (inputValue.length >= 2) {

                    getSubCategoryDetails({ page: 1, limit: 10, search: inputValue })((response) => {
                        if (response && response.status) {
                            setSubSubCategory(response?.data?.data?.SubSubcategorySizes?.map((item, index) => {
                                return {
                                    value: item.id,
                                    label: item.size
                                }

                            }));
                            resolve(response?.data?.data?.SubSubcategorySizes?.map((item, index) => {
                                return {
                                    value: item.id,
                                    label: item.size
                                }

                            }));
                        }
                    });
                }
                else {
                    resolve([]);
                    setSubSubCategory([])
                }

            }, 500);
        });
    }

    const onSizesChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            size: selectedOption ? selectedOption.value : '',
            selectedSize: selectedOption,
        });
    };



    const getStoresDetails = () => {
        getStoresListing()((response) => {
            if (response?.statusCode === 200) {
                setStore(response?.data?.[0]);
                if (user?.userType === "Vendor") {
                    formik.setFieldValue('manufacturerId', response?.data?.[0]?.id)
                }
            } else {

            }
        });
    };


    const getProducts = async () => {
        setFetching(true);
        getProductsDetails(id)(async (response) => {
            if (response?.data?.statusCode == 200) {
                const product = response?.data?.data?.product
                const selectedTagIds = product?.productTags?.map(tag => tag.tagId) || [];

                formik.setValues((prevState) =>
                ({

                    ...prevState,
                    productId: id,
                    thumbnailImageUrl: product?.thumbnailImageUrl || '',
                    productName: product?.productName ? product?.productName : '',
                    description: product?.description ? product?.description : '',
                    selectedCategory: {
                        value: product?.productSubcategory?.id ? product?.productSubcategory?.id : '',
                        label: product?.productSubcategory?.title ? product?.productSubcategory?.title : ''
                    },
                    selectedSubCategory: {
                        value: product?.productSubsubcategory?.id ? product?.productSubsubcategory?.id : '',
                        label: product?.productSubsubcategory?.title ? product?.productSubsubcategory?.title : ''
                    },
                    selectedManufacture: {
                        value: product?.manufacturer?.id ? product?.manufacturer?.id : '',
                        label: product?.manufacturer?.storeName ? product?.manufacturer?.storeName : ''
                    },
                    brandId: product?.brandId,
                    selectedBrand: {
                        value: product?.brand?.id ? product?.brand?.id : '',
                        label: product?.brand?.name ? product?.brand?.name : ''
                    },
                    subCategoryId: product?.productSubcategory?.id ? product?.productSubcategory?.id : '',
                    subSubCategoryId: product?.productSubsubcategory?.id ? product?.productSubsubcategory?.id : '',
                    manufacturerId: product?.manufacturer?.id ? product?.manufacturer?.id : '',
                    price: product?.price ? product?.price : '',
                    discountedPrice: product?.discountedPrice ? product?.discountedPrice : '',
                    images: [],
                    fabricType: product?.fabricType ? product?.fabricType : '',
                    sleeveType: product?.sleeveType ? product?.sleeveType : '',
                    fitType: product?.fitType ? product?.fitType : '',
                    neckType: product?.neckType ? product?.neckType : '',
                    color: product?.color ? product?.color : '',
                    stock: product?.stock ? product?.stock : '',
                    xtraSmall: product?.xtraSmall ? product?.xtraSmall : '',
                    small: product?.small ? product?.small : '',
                    medium: product?.medium ? product?.medium : '',
                    large: product?.large ? product?.large : '',
                    xtraLarge: product?.xtraLarge ? product?.xtraLarge : '',
                    specs: product?.specifications ? product?.specifications : [],
                    sizes: product?.productParameters?.length > 0 ? product?.productParameters?.[0]?.variation_sizes || [] : [],
                    variants: product?.variants ? product?.variants : [],
                    isActive: true,
                    tags: selectedTagIds,
                }))


                setOldImages(product?.images)
                setOldVariantImages([])
                setFetching(false)
            } else {
                setFetching(false)
            }
        })
    }



    const handleDeleteImage = (index) => {
        // If the image is from oldImages (already uploaded)
        if (oldImages && oldImages[index]) {
            const imageId = oldImages[index].id; // or use imageUrl/S3 key if your API expects that
            deleteProductImage(imageId)((response) => {
                if (response?.statusCode === 200) {
                    // Remove from UI state after successful deletion
                    const newOldImages = [...oldImages];
                    newOldImages.splice(index, 1);
                    setOldImages(newOldImages);
                    toast.success("Image deleted successfully");
                } else {
                    toast.error("Failed to delete image");
                }
            });
        } else {
            // For new images (not yet uploaded), just remove from Formik state
            const newFormikImages = [...formik.values.images];
            newFormikImages.splice(index, 1);
            formik.setFieldValue('images', newFormikImages);
        }
    };

    const [images, setImages] = useState(variantformik.values.variantImages || []);

    // Sync the local state with formik values whenever formik values change
    useEffect(() => {
        setImages(variantformik.values.variantImages || []);
    }, [variantformik.values.variantImages]);


    const handleDeleteVariantImage = (index) => {
        // Filter out the image to be deleted by its index
        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
        variantformik.setFieldValue('variantImages', updatedImages); // Update formik state
    };


    const deleteImage = (index) => {
        const updatedImages = [...oldVariantImages];
        updatedImages.splice(index, 1);
        setOldVariantImages(updatedImages);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleClickOutside = event => {
        if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
            setColorPickerVisible(false);
        }
    };

    const handleColorChange = (color) => {
        formik.setFieldValue('color', color.hex);
        setSelectedColor(color.hex);
    };
    const handleColorVaiantChange = (color) => {
        variantformik.setFieldValue('variantColor', color.hex);
        setSelectedColorVariant(color.hex);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
        variantformik.setFieldValue(name, trimmedValue);
    };


    useEffect(() => {
        if (formik?.values?.subCategoryId) {
            getSubCategoryListingPaginate({ page: 1, limit: 10, search: '', categoryIds: [formik?.values?.subCategoryId] })(response => {
                if (response?.statusCode == 200) {
                    setSubCategory(response?.results)
                } else {
                    setSubCategory([])
                }
            })


        }
    }, [formik?.values?.subCategoryId]);

    useEffect(() => {
        if (formik?.values?.subSubCategoryId) {
            getSubCategoryDetails(formik?.values?.subSubCategoryId)(response => {
                if (response?.data?.statusCode == 200) {
                    setSubSubCategory(response?.data?.data?.SubSubcategorySizes?.map((item, index) => {
                        return {
                            value: item.id,
                            label: item.size
                        }
                    }))
                    setSpecificationDrpDwn(response?.data?.data?.SubSubcategoryParameters?.map((item, index) => {
                        return {
                            value: item.id,
                            label: item.parameter
                        }
                    }))

                    // ✅ Add this to set tags from API response
                    setTags(response?.data?.data?.tags || []);
                } else {
                    setTags([]); // Reset tags if no data
                }
            })
        } else {
            setTags([]); // Reset tags when no subcategory selected
        }
    }, [formik?.values?.subSubCategoryId]);

    useEffect(() => {

        getStoresDetails()
        getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.statusCode == 200) {
                setCategory(response?.results)
            } else {
                setCategory([])
            }
        })

        getManufacturesListingPaginate({ page: 1, limit: 10, search: '' })(response => {
            if (response?.statusCode == 200) {
                setManufacturers(response?.results)
            } else {
            }
        })

    }, []);



    useEffect(() => {
        if (id) {
            setFetching(true)
            getProducts()
        }
    }, [update, id])

    const handleSpecificSubmit = () => {
        // Use Formik's setFieldValue to add the specification to the specs array
        const newSpec = { name: specificChange, value: "" };  // Example for a single name/value pair
        formik.setFieldValue('specs', [...formik.values.specs, newSpec]);

        // Close the modal
        setShowSpecification(false);
    };

    const handleVairantSpecificSubmit = () => {
        // Use Formik's setFieldValue to add the specification to the specs array
        const newSpec = { name: variantspecificChange, value: "" };  // Example for a single name/value pair
        variantformik.setFieldValue('specs', [...variantformik.values.specs, newSpec]);

        // Close the modal
        setShowVariantSpecification(false);
        setShow(true);
    };

    const handleDeleteSpecific = (indexToDelete) => {
        const updatedSpecs = formik.values.specs.filter((_, index) => index !== indexToDelete);
        formik.setFieldValue('specs', updatedSpecs);
    };

    const handleVariantDeleteSpecific = (indexToDelete) => {
        const updatedSpecs = variantformik.values.specs.filter((_, index) => index !== indexToDelete);
        variantformik.setFieldValue('specs', updatedSpecs);
    };

    const customNoOptionsMessage = ({ inputValue }) => {
        return inputValue.length < 2
            ? "Please type atleast 2 characters"
            : "No options";
    };

    const handleDeleteVariant = (indexToDelete) => {
        const updatedVariants = formik.values.variants.filter((_, index) => index !== indexToDelete);
        formik.setFieldValue('variants', updatedVariants); // Update formik state with the new variants array
    };


    const handleTagSelection = (tagId) => {
        const currentSelectedTags = [...formik.values.tags];
        const isSelected = currentSelectedTags.includes(tagId);

        if (isSelected) {
            // Remove tag if already selected
            const updatedTags = currentSelectedTags.filter(id => id !== tagId);
            formik.setFieldValue('tags', updatedTags);
        } else {
            // Add tag if not selected
            const updatedTags = [...currentSelectedTags, tagId];
            formik.setFieldValue('tags', updatedTags);
        }
    };

    // Helper function to check if a tag is selected
    const isTagSelected = (tagId) => {
        return formik.values.tags.includes(tagId);
    };


    return (
        <>

            {fetching ? (

                <Loader />

            ) : (
                <div>
                    <Row className="mb-4">
                        <Col>
                            <div className="page-title-box d-flex align-items-center mb-0">
                                <div
                                    onClick={() => navigate(-1)}
                                    style={{ cursor: 'pointer', fontSize: '24px', fontWeight: '800', display: 'flex', alignItems: 'center' }}
                                >
                                    <IoMdArrowBack className='icon' />
                                </div>
                                <h4 className="mb-0 fw-bold">{id ? 'Update' : 'Add New'} Product</h4>
                            </div>

                        </Col>
                    </Row>
                    <div className="">
                        <div className="">
                            <div className=''>
                                <div className=''>
                                    <Form onSubmit={formik.handleSubmit}>

                                        {/* Show Formik validation errors for debugging */}
                                        {/* {Object.keys(formik.errors).length > 0 && (
                                            <pre style={{ color: 'red' }}>{JSON.stringify(formik.errors, null, 2)}</pre>
                                        )}

                                        {Object.keys(formik.values).length > 0 && (
                                            <pre style={{ color: 'blue' }}>{JSON.stringify(formik.values, null, 2)}</pre>
                                        )} */}


                                        {/* Basic Product Information Card */}
                                        <Row>
                                            {/* Left Side - Product Details (8 grid) */}
                                            <Col md={7}>
                                                <Card className="mb-4 shadow-sm">
                                                    <Card.Header className="bg-light">
                                                        <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                            Product Details
                                                        </span>
                                                    </Card.Header>
                                                    <Card.Body className="p-4">
                                                        <Row>
                                                            <Col md={12}>
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Product Name *
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter product name"
                                                                        name="productName"
                                                                        value={formik.values?.productName}
                                                                        onChange={formik.handleChange}
                                                                        isValid={formik.touched.productName && !formik.errors.productName}
                                                                        isInvalid={formik.touched.productName && !!formik.errors.productName}
                                                                        className="rounded-input"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.productName}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={6}>
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Price *
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter price"
                                                                        name="price"
                                                                        value={formik.values?.price}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                                formik.setFieldValue("price", value);
                                                                            }
                                                                        }}
                                                                        isValid={formik.touched.price && !formik.errors.price}
                                                                        isInvalid={formik.touched.price && !!formik.errors.price}
                                                                        className="rounded-input"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.price}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={6}>
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Discounted Price
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter discounted price"
                                                                        name="discountedPrice"
                                                                        value={formik.values?.discountedPrice}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                                formik.setFieldValue("discountedPrice", value);
                                                                            }
                                                                        }}
                                                                        isValid={formik.touched.discountedPrice && !formik.errors.discountedPrice}
                                                                        isInvalid={formik.touched.discountedPrice && !!formik.errors.discountedPrice}
                                                                        className="rounded-input"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.discountedPrice}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={6}>

                                                                {/* Product Color */}
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Product Color *
                                                                    </Form.Label>
                                                                    <div style={{ position: "relative" }}>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Select product color"
                                                                            name="color"
                                                                            value={formik.values.color}
                                                                            onChange={formik.handleChange}
                                                                            isValid={formik.touched.color && !formik.errors.color}
                                                                            isInvalid={formik.touched.color && !!formik.errors.color}
                                                                            onFocus={() => setColorPickerVisible(true)}
                                                                            cursor="pointer"
                                                                            className="rounded-input"
                                                                            style={{
                                                                                borderRadius: "8px",
                                                                                padding: "8px 10px",
                                                                                fontSize: "13px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {formik.errors.color}
                                                                        </Form.Control.Feedback>
                                                                        {colorPickerVisible && (
                                                                            <div style={{ position: "absolute", zIndex: 999 }} ref={colorPickerRef}>
                                                                                <SketchPicker color={selectedColor} onChange={handleColorChange} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </Form.Group>

                                                            </Col>

                                                            <Col md={6}>  {/* Stock */}
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Total product Stock
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="--"
                                                                        name="stock"
                                                                        value={formik.values?.stock}
                                                                        onChange={formik.handleChange}
                                                                        isValid={formik.touched.stock && !formik.errors.stock}
                                                                        isInvalid={formik.touched.stock && !!formik.errors.stock}
                                                                        disabled
                                                                        className="rounded-input disabled_form_control"
                                                                        style={{
                                                                            borderRadius: "8px",
                                                                            padding: "8px 10px",
                                                                            fontSize: "13px",
                                                                            backgroundColor: "#f8f9fa",
                                                                        }}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.stock}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col md={12}>
                                                                <Form.Group className="mb-4">
                                                                    <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                        Product Description *
                                                                    </Form.Label>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={formik.values.description}
                                                                        className=".ck-editor__editable .ck-editor__editable_inline rounded-input"
                                                                        config={{
                                                                            placeholder: "Enter product description...",
                                                                        }}
                                                                        onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            formik.setFieldValue("description", data);
                                                                        }}
                                                                    />
                                                                    {formik.touched?.description && formik.errors?.description ? (
                                                                        <div className="custom-required" style={{ fontSize: "12px", color: "#DC3545" }}>
                                                                            Description is required
                                                                        </div>
                                                                    ) : null}
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>





                                            </Col>

                                            {/* Right Side - Parameters (4 grid) */}
                                            <Col md={5}>
                                                <Card className="mb-4 shadow-sm">
                                                    <Card.Header className="bg-light">
                                                        <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                            Parameters
                                                        </span>
                                                    </Card.Header>
                                                    <Card.Body className="p-4">
                                                        {/* Category */}
                                                        <Form.Group className="mb-4">
                                                            <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                Category *
                                                            </Form.Label>
                                                            <AsyncSelect
                                                                loadOptions={loadOptionsCategory}
                                                                defaultOptions={category}
                                                                classNamePrefix="select"
                                                                isClearable={true}
                                                                placeholder={"Search Categories"}
                                                                onChange={onCategoryChange}
                                                                value={formik.values.selectedCategory}
                                                                noOptionsMessage={customNoOptionsMessage}
                                                                styles={{
                                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        border: "1px solid #ced4da",
                                                                        borderRadius: "8px",
                                                                        minHeight: "40px",
                                                                        fontSize: "13px",
                                                                    }),
                                                                }}
                                                            />
                                                            <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                {formik.touched.selectedCategory && formik.errors.selectedCategory}
                                                            </div>
                                                        </Form.Group>

                                                        {/* Sub-Category */}
                                                        <Form.Group className="mb-4">
                                                            <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                Sub-Category *
                                                            </Form.Label>
                                                            <AsyncSelect
                                                                loadOptions={loadOptionsSubCategory}
                                                                defaultOptions={subcategory}
                                                                classNamePrefix="select"
                                                                isClearable={true}
                                                                placeholder={formik.values.subCategoryId !== '' ? "Search Sub Categories" : "Select a Category First"}
                                                                onChange={onSubCategoryChange}
                                                                value={formik.values.selectedSubCategory}
                                                                noOptionsMessage={customNoOptionsMessage}
                                                                isDisabled={formik.values.subCategoryId === ''}   // ✅ disables until category is selected
                                                                styles={{
                                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        border: "1px solid #ced4da",
                                                                        borderRadius: "8px",
                                                                        minHeight: "40px",
                                                                        fontSize: "13px",
                                                                        backgroundColor: formik.values.subCategoryId === '' ? '#f8f9fa' : '#fff', // greyed out look
                                                                    }),
                                                                }}
                                                            />

                                                            <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                {formik.touched.selectedSubCategory && formik.errors.selectedSubCategory}
                                                            </div>
                                                        </Form.Group>

                                                        {/* Vendor */}
                                                        {user?.userType !== "Vendor" && (
                                                            <Form.Group className="mb-4">
                                                                <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                    Vendor *
                                                                </Form.Label>
                                                                <AsyncSelect
                                                                    loadOptions={loadOptionsManufacture}
                                                                    defaultOptions={manufacturers}
                                                                    classNamePrefix="select"
                                                                    isClearable={true}
                                                                    placeholder="Search Vendors"
                                                                    onChange={onManufactureChange}
                                                                    value={formik.values.selectedManufacture}
                                                                    onMenuScrollToBottom={handleMenuScrollToBottomManufacture}
                                                                    noOptionsMessage={() =>
                                                                        hasMoreManufacture ? "Loading more options..." : "No more options"
                                                                    }
                                                                    styles={{
                                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            border: "1px solid #ced4da",
                                                                            borderRadius: "8px",
                                                                            minHeight: "40px",
                                                                            fontSize: "13px",
                                                                        }),
                                                                    }}
                                                                />
                                                                <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                    {formik.touched.selectedManufacture && formik.errors.selectedManufacture}
                                                                </div>
                                                            </Form.Group>
                                                        )}


                                                        {/* Brand */}
                                                        <Form.Group className="mb-4">
                                                            <Form.Label className="fw-semibold" style={{ fontSize: "13px" }}>
                                                                Brand *
                                                            </Form.Label>
                                                            <AsyncSelect
                                                                loadOptions={loadOptionsBrands}
                                                                defaultOptions={brands}
                                                                classNamePrefix="select"
                                                                isClearable={true}
                                                                placeholder={formik.values.manufacturerId !== '' ? "Search brands" : "Select a vendor First"}
                                                                onChange={onBrandChange}
                                                                value={formik.values.selectedBrand}
                                                                onMenuScrollToBottom={handleMenuScrollToBottom}
                                                                isDisabled={formik.values.manufacturerId === ''}
                                                                noOptionsMessage={() => (hasMore ? "Loading more options..." : "No more options")}
                                                                styles={{
                                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        border: "1px solid #ced4da",
                                                                        borderRadius: "8px",
                                                                        minHeight: "40px",
                                                                        fontSize: "13px",
                                                                        backgroundColor: formik.values.manufacturerId === '' ? '#f8f9fa' : '#fff', // greyed out look
                                                                    }),
                                                                }}
                                                            />
                                                            <div className="invalid-feedbacks" style={{ color: "#DC3544", fontSize: "12px" }}>
                                                                {formik.touched.selectedBrand && formik.errors.selectedBrand}
                                                            </div>
                                                        </Form.Group>



                                                    </Card.Body>
                                                </Card>

                                                {/* Product Images Card */}
                                                <Card className="mb-4 shadow-sm">
                                                    <Card.Header className="bg-light">
                                                        <span style={{ fontSize: "16px", fontWeight: "700" }}>
                                                            Product Images
                                                        </span>
                                                    </Card.Header>
                                                    <Card.Body className="p-4">
                                                        {/* Compute the current thumbnail URL */}
                                                        {(() => {
                                                            let currentThumbnailUrl = "";

                                                            if (formik.values.thumbnailImageUrl) {
                                                                // try to match with old images
                                                                const oldMatch = oldImages?.find(img =>
                                                                    img.imageUrl.includes(formik.values.thumbnailImageUrl)
                                                                );
                                                                if (oldMatch) {
                                                                    currentThumbnailUrl = oldMatch.imageUrl;
                                                                }

                                                                // if not in old images, check newly added images
                                                                if (!currentThumbnailUrl && formik.values.images?.length > 0) {
                                                                    const newImg = formik.values.images.find(img =>
                                                                        typeof img === "string"
                                                                            ? img.includes(formik.values.thumbnailImageUrl)
                                                                            : false
                                                                    );
                                                                    if (newImg) {
                                                                        currentThumbnailUrl = newImg;
                                                                    }
                                                                }
                                                            }

                                                            return (
                                                                <div
                                                                    className="position-relative rounded mb-3"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "300px",
                                                                        overflow: "hidden",
                                                                        borderRadius: "12px",
                                                                        border: "1px solid #dee2e6",
                                                                    }}
                                                                >
                                                                    {currentThumbnailUrl ? (
                                                                        <>
                                                                            <img
                                                                                src={currentThumbnailUrl}
                                                                                alt="Thumbnail"
                                                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                            />
                                                                            <div
                                                                                className="position-absolute bottom-0 start-0 w-100 text-white text-center py-1"
                                                                                style={{ fontSize: "13px", background: "rgba(0,0,0,0.6)" }}
                                                                            >
                                                                                Thumbnail
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <div
                                                                            className="d-flex align-items-center justify-content-center h-100 text-muted"
                                                                            style={{ fontSize: "14px" }}
                                                                        >
                                                                            No thumbnail selected
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })()}


                                                        {/* Product Images Row (horizontal scroller) */}
                                                        <div
                                                            className="d-flex gap-2 pb-2 align-items-center justify-content-start custom-scrollbar"
                                                            style={{
                                                                minHeight: "80px", // keeps row height
                                                                overflowX: "auto",
                                                                overflowY: "hidden",
                                                                whiteSpace: "nowrap",
                                                                border: "1px dashed #dee2e6",
                                                                borderRadius: "6px",
                                                                maxWidth: "100%", // ✅ ensures container doesn’t overflow
                                                            }}
                                                        >
                                                            <style>
                                                                {`
      .custom-scrollbar::-webkit-scrollbar {
        display: none;
      }
      .custom-scrollbar {
        -ms-overflow-style: none; /* IE/Edge */
        scrollbar-width: none; /* Firefox */
      }
    `}
                                                            </style>

                                                            {oldImages?.length > 0 || formik.values.images?.length > 0 ? (
                                                                <>
                                                                    {/* Old Images */}
                                                                    {oldImages?.map((image, i) => {
                                                                        const isThumbnail =
                                                                            formik.values.thumbnailImageUrl &&
                                                                            image?.imageUrl?.includes(formik.values.thumbnailImageUrl);

                                                                        return (
                                                                            <div
                                                                                key={`old-${i}`}
                                                                                className="position-relative"
                                                                                style={{
                                                                                    width: "80px",
                                                                                    height: "80px",
                                                                                    flex: "0 0 auto",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                {/* Click to select thumbnail */}
                                                                                <img
                                                                                    src={image?.imageUrl}
                                                                                    alt="product"
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        objectFit: "cover",
                                                                                        borderRadius: "6px",
                                                                                        border: isThumbnail ? "3px solid #00b1beff" : "1px solid #ddd",
                                                                                    }}
                                                                                    onClick={() => handleThumbnailSelect(i, true)}
                                                                                />

                                                                                {/* Remove button */}
                                                                                <IoClose
                                                                                    className="position-absolute top-0 end-0 m-1 bg-black rounded-circle shadow-sm"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        fontSize: "14px",
                                                                                        color: "#ffffffff",
                                                                                        background: "#00000088",
                                                                                        padding: "2px"
                                                                                    }}
                                                                                    onClick={() => handleDeleteImage(i)}
                                                                                />
                                                                            </div>
                                                                        );
                                                                    })}

                                                                    {/* New Images */}
                                                                    {formik.values.images?.map((image, index) => {
                                                                        const imageUrl =
                                                                            typeof image === "string" ? image : URL.createObjectURL(image);

                                                                        const isThumbnail =
                                                                            formik.values.thumbnailImageUrl &&
                                                                            (typeof image === "string"
                                                                                ? image.includes(formik.values.thumbnailImageUrl)
                                                                                : false);

                                                                        return (
                                                                            <div
                                                                                key={`new-${index}`}
                                                                                className="position-relative"
                                                                                style={{
                                                                                    width: "80px",
                                                                                    height: "80px",
                                                                                    flex: "0 0 auto",
                                                                                    cursor: "pointer",
                                                                                    border: isThumbnail ? "3px solid #00b1beff" : "1px solid #ddd",
                                                                                    borderRadius: "6px",
                                                                                    overflow: "hidden",
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={imageUrl}
                                                                                    alt={`Uploaded ${index}`}
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "100%",
                                                                                        objectFit: "cover",
                                                                                    }}
                                                                                    onClick={() => handleThumbnailSelect(index, false)}
                                                                                />

                                                                                {/* Remove button */}
                                                                                <IoClose
                                                                                    className="position-absolute top-0 end-0 m-1 bg-black rounded-circle shadow-sm"
                                                                                    style={{
                                                                                        cursor: "pointer",
                                                                                        fontSize: "14px",
                                                                                        color: "#ffffffff",
                                                                                        background: '#00000088',
                                                                                        padding: "2px"
                                                                                    }}
                                                                                    onClick={() => handleDeleteImage(index)}
                                                                                />
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </>
                                                            ) : (
                                                                <span className="text-muted" style={{ fontSize: "14px", alignItems: "center", justifyContent: "center", display: "flex", height: "80px", width: "100%" }}>
                                                                    Product images appear here
                                                                </span>
                                                            )}
                                                        </div>


                                                        {/* Full-width Add More Button */}
                                                        <label
                                                            htmlFor="fileInput"
                                                            className="d-flex flex-column align-items-center justify-content-center text-center mt-3"
                                                            style={{
                                                                width: "100%",
                                                                height: "40px",
                                                                border: "2px dashed #000000ff",
                                                                borderRadius: "10px",
                                                                cursor: "pointer",
                                                                color: "#000000ff",
                                                                fontWeight: "500",
                                                                transition: "all 0.3s ease",
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.borderColor = "#000000ff";
                                                                e.currentTarget.style.backgroundColor = "#ebebebff";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.borderColor = "#000000ff";
                                                                e.currentTarget.style.backgroundColor = "transparent";
                                                            }}
                                                        >
                                                            <span style={{ fontSize: "14px", }}>
                                                                <FiPlus /> Add More Images
                                                            </span>
                                                        </label>
                                                        <input
                                                            id="fileInput"
                                                            className="d-none"
                                                            type="file"
                                                            multiple
                                                            onChange={handleImageChange}
                                                            accept="image/*"
                                                        />
                                                    </Card.Body>
                                                </Card>
                                            </Col>







                                        </Row>


                                        {/* Product Tags Card */}
                                        <Card className="mb-4 shadow-sm">
                                            <Card.Header className="bg-light">
                                                <Row className="flex-column">
                                                    <span style={{ fontSize: '16px', fontWeight: '700' }}>
                                                        Product Tags
                                                    </span>

                                                    {tags.length === 0 && formik.values.selectedSubCategory !== '' ? (
                                                        <span style={{ fontSize: '12px', fontWeight: '400', color: '#6c757d' }}>
                                                            No tags available for the selected subcategory
                                                        </span>
                                                    ) : tags.length > 0 ? (
                                                        <span style={{ fontSize: '12px', fontWeight: '400', color: '#6c757d' }}>
                                                            Click on tags to select/deselect them
                                                        </span>
                                                    ) : (
                                                        <span style={{ fontSize: '12px', fontWeight: '400', color: '#6c757d' }}>
                                                            Select a subcategory to load available tags
                                                        </span>
                                                    )}
                                                </Row>
                                            </Card.Header>

                                            <Card.Body className="px-4 py-5">
                                                {/* Check if subcategory is selected */}
                                                {formik.values.selectedSubCategory === '' ? (
                                                    <p className="text-muted text-center my-4" style={{ fontSize: '14px' }}>
                                                        Please select a subcategory to view available tags
                                                    </p>
                                                ) : tags.length > 0 ? (
                                                    <div className="d-flex flex-wrap gap-3 justify-content-start">

                                                        {tags.map((tag, index) => {
                                                            const isSelected = isTagSelected(tag.id);

                                                            return (
                                                                <div
                                                                    key={tag.id}
                                                                    className="d-flex flex-column align-items-center position-relative"
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease',
                                                                        transform: isSelected ? 'scale(1.05)' : 'scale(1)',
                                                                    }}
                                                                    onClick={() => handleTagSelection(tag.id)}
                                                                >
                                                                    {/* Tag Image with Border */}
                                                                    <div
                                                                        className="rounded-circle overflow-hidden position-relative"
                                                                        style={{
                                                                            width: '80px',
                                                                            height: '80px',
                                                                            border: isSelected ? '3px solid #288d9dff' : '1px solid #dee2e6',
                                                                            padding: '2px',
                                                                            transition: 'all 0.3s ease',
                                                                            // boxShadow: isSelected ? '0 1px 1px #288d9dff' : 'none',
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={tag.tagImageUrl}
                                                                            alt={tag.tagName}
                                                                            style={{
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                objectFit: 'cover',
                                                                                borderRadius: '50%',
                                                                            }}
                                                                        />

                                                                        {/* Selection Checkmark */}
                                                                        {/* {isSelected && (
                                                                            <div
                                                                                className="position-absolute bg-success rounded-circle d-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    width: '20px',
                                                                                    height: '20px',
                                                                                    transform: 'translate(70%, -100%)',
                                                                                }}
                                                                            >
                                                                                <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>
                                                                                    ✓
                                                                                </span>
                                                                            </div>
                                                                        )} */}
                                                                    </div>

                                                                    {/* Tag Name */}
                                                                    <span
                                                                        className="mt-2 text-center"
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            fontWeight: isSelected ? '600' : '400',
                                                                            color: '#000000ff',
                                                                            maxWidth: '80px',
                                                                            wordWrap: 'break-word',
                                                                        }}
                                                                    >
                                                                        {tag.tagName}
                                                                    </span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    <p className="text-muted text-center py-5" style={{ fontSize: '14px' }}>
                                                        No tags available for the selected subcategory
                                                    </p>
                                                )}

                                                {/* Selected Tags Summary */}
                                                {/* {formik.values.tags.length > 0 && (
                                                    <div className="mt-4 p-3 bg-light rounded">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#28a745' }}>
                                                                Selected Tags ({formik.values.tags.length}):
                                                            </span>
                                                            <div className="d-flex flex-wrap gap-2">
                                                                {tags
                                                                    .filter(tag => formik.values.tags.includes(tag.id))
                                                                    .map(tag => (
                                                                        <span
                                                                            key={tag.id}
                                                                            className="badge bg-success"
                                                                            style={{ fontSize: '12px' }}
                                                                        >
                                                                            {tag.tagName}
                                                                        </span>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )} */}
                                            </Card.Body>
                                        </Card>

                                        {/* Sizes Stocks Card */}
                                        <Card className="mb-4">
                                            <Card.Header
                                                className={"bg-light"}
                                            >
                                                <Row className="flex-column">
                                                    <span style={{ fontSize: '18px', fontWeight: '700' }}>
                                                        Product Sizes / Stocks
                                                    </span>

                                                    {formik.values.sizes.length === 0 && formik.values.selectedCategory !== '' && formik.values.selectedSubcategory !== '' ? (
                                                        <span style={{ fontSize: '12px', fontWeight: '400', color: 'red' }}>
                                                            Select sizes and enter stock quantities!
                                                        </span>
                                                    ) : (
                                                        <span style={{ fontSize: '12px', fontWeight: '400', color: '#6c757d' }}>
                                                            Select sizes and enter stock quantities.
                                                        </span>
                                                    )}
                                                </Row>
                                            </Card.Header>

                                            <Card.Body className="px-4 py-5">
                                                {subsubcategory.length > 0 ? (
                                                    <div className="d-flex flex-wrap" style={{ gap: '16px' }}>
                                                        {subsubcategory.slice().reverse().map((option, index) => {
                                                            const selectedSize = formik.values.sizes.find(s => s.size === option.label);

                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className="d-flex align-items-center border rounded p-3"
                                                                    style={{
                                                                        width: '200px',
                                                                        gap: '12px', // space between checkbox, label, and input
                                                                        backgroundColor: '#f9f9f9',
                                                                    }}
                                                                >
                                                                    {/* Checkbox */}
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        checked={!!selectedSize}
                                                                        onChange={(e) =>
                                                                            handleSizeCheckboxChange(option.label, e.target.checked)
                                                                        }
                                                                        className="custom-checkbox"
                                                                        style={{
                                                                            transform: 'scale(1.4)',
                                                                            marginRight: '8px',
                                                                        }}
                                                                    />


                                                                    {/* Size Label */}
                                                                    <span
                                                                        style={{
                                                                            flex: '1 1 auto',
                                                                            fontWeight: 600,
                                                                            fontSize: '14px',
                                                                        }}
                                                                    >
                                                                        {option.label}
                                                                    </span>

                                                                    {/* Stock Input */}
                                                                    {selectedSize && (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={selectedSize.stock}
                                                                            placeholder="Stock"
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                if (/^\d*$/.test(value))
                                                                                    handleProductSizeStockChangeByName(option.label, e);
                                                                            }}
                                                                            style={{
                                                                                width: '70px',
                                                                                borderRadius: '6px',
                                                                                border: '1px solid #ccc',
                                                                                textAlign: 'center',
                                                                                padding: '6px',
                                                                                fontSize: '14px',
                                                                                backgroundColor: '#fff',
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (

                                                    <>




                                                        <p className="text-muted text-center my-5" style={{ fontSize: '14px' }}>
                                                            {formik.values.selectedSubCategory == '' ? 'Please select category and subcategory to load sizes' : 'No sizes found for the selected subcategory'}


                                                        </p>
                                                    </>



                                                )}
                                            </Card.Body>
                                        </Card>




                                        {/* Specifications Card */}
                                        <Card className="mb-4">
                                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                                <span style={{ fontSize: '16px', fontWeight: '700' }}>Specifications</span>
                                                <Button
                                                    onClick={handleSpecificationAdd}
                                                    variant="outline-dark"
                                                    className="subcategory-add-button"
                                                    disabled={formik.values.selectedCategory === '' || formik.values.selectedSubCategory === ''} // ✅ disable Add Specification button
                                                >
                                                    <FiPlus /> Add Specification
                                                </Button>
                                            </Card.Header>

                                            <div className="specifications-wrapper">
                                                {/* Check if category + subcategory are selected */}
                                                {formik.values.selectedCategory === '' || formik.values.selectedSubCategory === '' ? (
                                                    <div className="text-center my-5 py-4">
                                                        <p className="text-muted" style={{ fontSize: '14px' }}>
                                                            Please select category and subcategory to add specifications
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {/* Specifications List */}
                                                        {formik?.values?.specs.length > 0 ? (
                                                            formik.values.specs.map((item, index) => {
                                                                // Get a list of already selected values
                                                                const selectedValues = formik.values.specs.map((spec) => spec.name);

                                                                // Filter the options to exclude already selected values
                                                                const availableSpecsOptions = specificationDrpdwn.filter(
                                                                    (option) => !selectedValues.includes(option.label) || option.label === item.name
                                                                );

                                                                return (
                                                                    <div key={index} className="specification-row mb-4 p-3 border rounded">
                                                                        <div className="d-flex align-items-start justify-content-between">
                                                                            <div className="d-flex align-items-start gap-4 flex-grow-1">
                                                                                {/* Specification Dropdown */}
                                                                                <Form.Group className="specification-select-group flex-grow-1">
                                                                                    <Form.Label className="form-label-custom d-block mb-2">
                                                                                        Specification
                                                                                    </Form.Label>
                                                                                    <Select
                                                                                        placeholder='Select Specification'
                                                                                        options={availableSpecsOptions}
                                                                                        value={specificationDrpdwn.find(option => option.label === item.name)}
                                                                                        onChange={(selectedOption) => handleProductSpecificationChange(index, selectedOption)}
                                                                                        theme={(theme) => ({
                                                                                            ...theme,
                                                                                            borderRadius: "8px",
                                                                                            colors: {
                                                                                                ...theme.colors,
                                                                                                primary: '#779be1',
                                                                                            },
                                                                                        })}
                                                                                        styles={{
                                                                                            menu: (baseStyles) => ({
                                                                                                ...baseStyles,
                                                                                                zIndex: 9999,
                                                                                            }),
                                                                                            control: (provided, state) => ({
                                                                                                ...provided,
                                                                                                border: "1px solid #ddd",
                                                                                                padding: '8px 12px',
                                                                                                minHeight: '48px',
                                                                                                borderRadius: '8px',
                                                                                                boxShadow: 'none',
                                                                                                '&:hover': {
                                                                                                    borderColor: '#779be1'
                                                                                                },
                                                                                                borderColor: state.isFocused ? '#779be1' : '#ddd',
                                                                                            }),
                                                                                            placeholder: (provided) => ({
                                                                                                ...provided,
                                                                                                color: '#6c757d',
                                                                                            }),
                                                                                        }}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>

                                                                                {/* Specification Value Input */}
                                                                                {item.name && (
                                                                                    <Form.Group className="specification-value-group flex-grow-1">
                                                                                        <Form.Label className="form-label-custom d-block mb-2">
                                                                                            {specificationDrpdwn.find(option => option.label === item.name)?.label}
                                                                                        </Form.Label>
                                                                                        <div className="d-flex align-items-center gap-2">
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                name={`specs[${index}].value`}
                                                                                                value={item.value}
                                                                                                onChange={formik.handleChange}
                                                                                                isValid={formik.touched.specs?.[index]?.value && !formik.errors.specs?.[index]?.value}
                                                                                                isInvalid={formik.touched.specs?.[index]?.value && !!formik.errors.specs?.[index]?.value}
                                                                                                className="specification-input"
                                                                                                style={{
                                                                                                    height: '48px',
                                                                                                    padding: '12px 16px'
                                                                                                }}
                                                                                                placeholder={`Enter ${specificationDrpdwn.find(option => option.label === item.name)?.label}`}
                                                                                                required
                                                                                            />
                                                                                        </div>
                                                                                        <Form.Control.Feedback type="invalid">
                                                                                            {formik.errors.specs?.[index]?.value}
                                                                                        </Form.Control.Feedback>
                                                                                    </Form.Group>
                                                                                )}
                                                                            </div>

                                                                            {/* Delete Button */}
                                                                            <div className="delete-section ms-3" style={{ marginTop: '32px' }}>
                                                                                <MdDeleteOutline
                                                                                    role='button'
                                                                                    onClick={() => handleDeleteSpecific(index)}
                                                                                    style={{
                                                                                        fontSize: "24px",
                                                                                        color: "#dc3545",
                                                                                    }}
                                                                                    className="delete-spec-btn"
                                                                                    title="Delete specification"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div className="text-center my-5 py-4">
                                                                <p className="text-muted">
                                                                    Add new specification
                                                                </p>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>


                                        </Card>



                                        {/* Product Variants Card */}
                                        <Card className="mb-4 shadow-sm">
                                            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                                                <span style={{ fontSize: '16px', fontWeight: '700' }}>Product Variants</span>
                                                <Button
                                                    onClick={handleShow}
                                                    variant="outline-dark"
                                                    className="subcategory-add-button"
                                                    disabled={formik.values.selectedCategory === '' || formik.values.selectedSubCategory === ''} // ✅ disable Add Variant button if not selected
                                                >
                                                    <FiPlus /> Add Variant
                                                </Button>
                                            </Card.Header>

                                            <Card.Body className="px-4 py-5">
                                                {/* Check if category + subcategory are selected */}
                                                {formik.values.selectedCategory === '' || formik.values.selectedSubCategory === '' ? (
                                                    <p className="text-muted text-center my-5" style={{ fontSize: '14px' }}>
                                                        Please select category and subcategory to add variants
                                                    </p>
                                                ) : (
                                                    <>
                                                        {/* Variants List */}
                                                        {formik.values.variants.length > 0 ? (
                                                            <div className="d-flex flex-wrap gap-2 mb-3">
                                                                {formik.values.variants.map((variant, index) => (
                                                                    <div key={index} className="d-flex align-items-center me-3">
                                                                        <Button className="request_btn">
                                                                            <div
                                                                                className="color_code"
                                                                                style={{ backgroundColor: variant.variantColor }}
                                                                            ></div>
                                                                            Variant {index + 1}
                                                                        </Button>
                                                                        <MdDeleteOutline
                                                                            role="button"
                                                                            onClick={() => handleDeleteVariant(index)}
                                                                            style={{
                                                                                fontSize: "25px",
                                                                                color: "red",
                                                                                marginLeft: "10px",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ) : (
                                                            <p className="text-muted text-center my-5">
                                                                Add new variant
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            </Card.Body>
                                        </Card>









                                        {/* Action Buttons */}
                                        <div className="d-flex justify-content-end gap-3 mt-4 p-3 bg-white" style={{ zIndex: 1000 }}>
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => cancelStore()}
                                                className="cancel_btn"

                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                disabled={loading}
                                                className="request_btn"

                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" />
                                                        Processing...
                                                    </>
                                                ) : id ? (
                                                    'Update Product'
                                                ) : (
                                                    'Add New Product'
                                                )}
                                            </Button>
                                        </div>


                                    </Form>
                                    {/* Add varient */}
                                    <Modal
                                        show={show}
                                        onHide={handleClose}
                                        centered
                                        className='modal_create'
                                        size='lg'
                                        backdrop="static"
                                    >
                                        <Form onSubmit={variantformik.handleSubmit}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Add Variant</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className='modal_content_wrapper'>
                                                    <div className='row'>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Product Name</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantName'
                                                                    value={variantformik.values?.variantName}
                                                                    onChange={variantformik.handleChange}
                                                                    isValid={variantformik.touched.variantName && !variantformik.errors.variantName}
                                                                    isInvalid={variantformik.touched.variantName && !!variantformik.errors.variantName}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantName}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                                <Form.Label>Color</Form.Label>
                                                                <div style={{ position: 'relative' }}>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder=""
                                                                        name='variantColor'
                                                                        value={variantformik.values.variantColor}
                                                                        onChange={variantformik.handleChange}
                                                                        isValid={variantformik.touched.variantColor && !variantformik.errors.variantColor}
                                                                        isInvalid={variantformik.touched.variantColor && !!variantformik.errors.variantColor}
                                                                        onFocus={() => setColorPickerVisible(true)}
                                                                        // onBlur={() => setColorPickerVisible(false)}
                                                                        readOnly
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{variantformik.errors.variantColor}</Form.Control.Feedback>

                                                                    {colorPickerVisible && (
                                                                        <div style={{ position: 'absolute', zIndex: 999 }} ref={colorPickerRef}>
                                                                            <SketchPicker
                                                                                color={selectedColorVariant}
                                                                                onChange={handleColorVaiantChange}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                                <Form.Label>Stock</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantStock'
                                                                    value={variantformik.values?.variantStock}
                                                                    onChange={variantformik.handleChange}
                                                                    isValid={variantformik.touched.variantStock && !variantformik.errors.variantStock}
                                                                    isInvalid={variantformik.touched.variantStock && !!variantformik.errors.variantStock}
                                                                    disabled
                                                                    className='disabled_form_control'
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantStock}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Price</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantPrice'
                                                                    value={variantformik.values?.variantPrice}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        // Allow only numbers and prevent negative values
                                                                        if (/^\d*\.?\d*$/.test(value)) {
                                                                            variantformik.setFieldValue("variantPrice", value);
                                                                        }
                                                                    }}
                                                                    isValid={variantformik.touched.variantPrice && !variantformik.errors.variantPrice}
                                                                    isInvalid={variantformik.touched.variantPrice && !!variantformik.errors.variantPrice}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantPrice}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Discount Price</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='variantDiscountedPrice'
                                                                    value={variantformik.values?.variantDiscountedPrice}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        // Allow only numbers and prevent negative values
                                                                        if (/^\d*\.?\d*$/.test(value)) {
                                                                            variantformik.setFieldValue("variantDiscountedPrice", value);
                                                                        }
                                                                    }}
                                                                    isValid={variantformik.touched.variantDiscountedPrice && !variantformik.errors.variantDiscountedPrice}
                                                                    isInvalid={variantformik.touched.variantDiscountedPrice && !!variantformik.errors.variantDiscountedPrice}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{variantformik.errors.variantDiscountedPrice}</Form.Control.Feedback>
                                                            </Form.Group>
                                                        </div>
                                                        <div className='col-lg-12'>
                                                            <Form.Label>Product Images</Form.Label>
                                                            <Form.Group className="br_border mb-3">
                                                                <label htmlFor="fileInputVariant" className="custom-file-upload-product">
                                                                    <img src={upload} className='upload_icon img-fluid' alt='Upload' />
                                                                </label>
                                                                <input
                                                                    id="fileInputVariant"
                                                                    className='file_type'
                                                                    type="file"
                                                                    multiple
                                                                    onChange={handleImageVariantChange}
                                                                />
                                                                <div className="d-flex flex-row align-items-center justify-content-start gap-3">
                                                                    <div className="uploaded-images">
                                                                        {oldVariantImages?.map((image, i) =>
                                                                            <div className='pos-rel' key={i}>
                                                                                <img src={image?.imageUrl} alt="product" className="uploaded-image" />
                                                                                <IoClose className='icon_close' onClick={() => deleteImage(i)} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {/* Display uploaded images */}
                                                                    <div className="uploaded-images">
                                                                        {variantformik.values.variantImages?.map((image, index) => (
                                                                            <div className='pos-rel' key={index}>
                                                                                <img key={index} src={image} alt={`Uploaded ${index}`} className="uploaded-image" />
                                                                                <IoClose className='icon_close' onClick={() => handleDeleteVariantImage(index)} />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                                <div className='invalid-feedbacks' style={{ color: '#DC3544' }}>{variantformik.touched.variantImages && variantformik.errors.variantImages}</div>

                                                            </Form.Group>
                                                        </div>
                                                        {/* Add Size Fields */}
                                                        <div className='col-lg-12'>
                                                            <div className='row align-items-center btn_wrapper_add_size'>
                                                                <div className='col-lg-8'>
                                                                    {variantformik.values.variantSizes[0].sizes.map((item, index) => {

                                                                        const isFirstItem = index === 0;
                                                                        const isLastItem = index === formik.values.sizes.length - 1; // Check if this is the last item
                                                                        const shouldApplyRightBorder = ((index + 1) % 3 !== 0) && !isLastItem; // Apply br_right only if not the 3rd item and not the last item
                                                                        // Get a list of already selected values
                                                                        const selectedValues = variantformik.values.variantSizes[0].sizes.map((size) => size.size);

                                                                        // Filter the options to exclude already selected values
                                                                        const availableSizeOptions = subsubcategory.filter(
                                                                            (option) => !selectedValues.includes(option.label) || option.label === item.size
                                                                        );
                                                                        return (
                                                                            <div key={index} className='d-flex align-items-center mt-3'>

                                                                                <div className='d-flex align-items-baseline'>
                                                                                    <Form.Group className="mb-3 me-3">
                                                                                        {index === 0 && <Form.Label>Size</Form.Label>}
                                                                                        <Select
                                                                                            placeholder='Select Size'
                                                                                            options={availableSizeOptions}
                                                                                            value={subsubcategory.find(option => option.value === item.size)} // Select value for current size
                                                                                            onChange={(selectedOption) => handleSizeSelectChange(index, selectedOption)} // Custom handler for Select
                                                                                            theme={(theme) => ({
                                                                                                ...theme,
                                                                                                borderRadius: "0 10px 10px 10px",
                                                                                                colors: {
                                                                                                    ...theme.colors,
                                                                                                    primary: '#779be1',
                                                                                                },
                                                                                            })}
                                                                                            styles={{
                                                                                                menu: (baseStyles) => ({
                                                                                                    ...baseStyles,
                                                                                                    zIndex: 9999,
                                                                                                }),
                                                                                                control: (provided) => ({
                                                                                                    ...provided,
                                                                                                    border: "1px solid #a7a7a7",
                                                                                                    padding: '6px',
                                                                                                    width: '220px'
                                                                                                }),
                                                                                            }}
                                                                                            required
                                                                                        />
                                                                                    </Form.Group>

                                                                                    <Form.Group className="mb-3 me-3">
                                                                                        {index === 0 && <Form.Label>Stock</Form.Label>}
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            placeholder="Enter stock"
                                                                                            name='stock'
                                                                                            value={item.stock}
                                                                                            onChange={(e) => {
                                                                                                const value = e.target.value;

                                                                                                if (/^\d*$/.test(value)) {
                                                                                                    handleSizeStockChange(index, e);
                                                                                                }
                                                                                            }}
                                                                                            required
                                                                                        />
                                                                                    </Form.Group>
                                                                                </div>

                                                                                <MdDeleteOutline
                                                                                    role='button'
                                                                                    onClick={() => handleDeleteSizeStock(index)}
                                                                                    style={{ fontSize: "25px", color: "red" }}
                                                                                    className={`delete_size_btn ${index === 0 ? 'mt-2' : 'mb-4'}`}
                                                                                />
                                                                                {/* <Button variant="danger" className={`delete_size_btn ${index === 0 ? 'mt-2' : 'mb-4'}`} >
                                                                            <IoClose />
                                                                        </Button> */}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                                {variantformik.values.variantSizes[0].sizes.length > 0 && (
                                                                    <div className='br_bottom'></div>
                                                                )}
                                                                <div className='col-lg-12'>
                                                                    <div className='store_details_wrapper_custom'>
                                                                        <div className='form_wrapper'>
                                                                            <div className='row'>
                                                                                {variantformik.values.specs.map((item, index) => {
                                                                                    const isLastItem = index === variantformik.values.specs.length - 1; // Check if this is the last item
                                                                                    const shouldApplySpecRightBorder = ((index + 1) % 3 !== 0) && !isLastItem; // Apply br_right only if not the 3rd item and not the last item

                                                                                    // Get a list of already selected values
                                                                                    const selectedValues = variantformik.values.specs.map((spec) => spec.name);

                                                                                    // Filter the options to exclude already selected values
                                                                                    const availableSpecsOptions = specificationDrpdwn.filter(
                                                                                        (option) => !selectedValues.includes(option.label) || option.label === item.name
                                                                                    );
                                                                                    return (
                                                                                        <div key={index} className='d-flex align-items-center mt-3 gap-2'>

                                                                                            <div className='d-flex align-items-baseline'>
                                                                                                <Form.Group className="mb-3 me-3">
                                                                                                    <Form.Label>Specifications</Form.Label>
                                                                                                    <Select
                                                                                                        placeholder='Select Specification'
                                                                                                        options={availableSpecsOptions}
                                                                                                        value={specificationDrpdwn.find(option => option.value === item.name)} // Select value for current size
                                                                                                        onChange={(selectedOption) => handleVariantSpecificationChange(index, selectedOption)} // Custom handler for Select
                                                                                                        theme={(theme) => ({
                                                                                                            ...theme,
                                                                                                            borderRadius: "0 10px 10px 10px",
                                                                                                            colors: {
                                                                                                                ...theme.colors,
                                                                                                                primary: '#779be1',
                                                                                                            },
                                                                                                        })}
                                                                                                        styles={{
                                                                                                            menu: (baseStyles) => ({
                                                                                                                ...baseStyles,
                                                                                                                zIndex: 9999,
                                                                                                            }),
                                                                                                            control: (provided) => ({
                                                                                                                ...provided,
                                                                                                                border: "1px solid #a7a7a7",
                                                                                                                padding: '6px',
                                                                                                                width: '220px'
                                                                                                            }),
                                                                                                        }}
                                                                                                        required
                                                                                                    />
                                                                                                </Form.Group>

                                                                                                {/* Conditionally render the input field based on whether a specification is selected */}
                                                                                                {item.name && (
                                                                                                    <Form.Group className="mb-3" controlId={`specs.${index}.value`}>
                                                                                                        {/* Use the selected specification label as the input label */}
                                                                                                        <Form.Label>{specificationDrpdwn.find(option => option.label === item.name)?.label}</Form.Label>
                                                                                                        <div className='form_del_control'>
                                                                                                            <Form.Control
                                                                                                                type="text"
                                                                                                                name={`specs[${index}].value`}
                                                                                                                value={item.value}
                                                                                                                onChange={variantformik.handleChange}
                                                                                                                isValid={variantformik.touched.specs?.[index]?.value && !variantformik.errors.specs?.[index]?.value}
                                                                                                                isInvalid={variantformik.touched.specs?.[index]?.value && !!variantformik.errors.specs?.[index]?.value}
                                                                                                                required
                                                                                                            />
                                                                                                        </div>
                                                                                                        <Form.Control.Feedback type="invalid">
                                                                                                            {formik.errors.specs?.[index]?.value}
                                                                                                        </Form.Control.Feedback>
                                                                                                    </Form.Group>
                                                                                                )}
                                                                                            </div>

                                                                                            <MdDeleteOutline
                                                                                                role='button'
                                                                                                onClick={() => handleVariantDeleteSpecific(index)}
                                                                                                style={{ fontSize: "25px", color: "red" }}
                                                                                                className={`delete_size_btn mt-4`}
                                                                                            />
                                                                                        </div>
                                                                                    )


                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                {variantformik.values.specs.length > 0 && (
                                                                    <div className='br_bottom'></div>
                                                                )}
                                                                <div className='btn_groups'>
                                                                    <Button className="request_btn" onClick={handleAddSize}>
                                                                        <BiPlus /> Add Size
                                                                    </Button>

                                                                    <Button className="request_btn" onClick={handleVariantSpecificationAdd}>
                                                                        <BiPlus /> Add Specification
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>



                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button className='cancle_btn' onClick={handleClose}>
                                                    Cancel
                                                </Button>
                                                <Button className='submit_btn' type='submit'>
                                                    {loading ? "Loading" : id ? "Update Variant" : "Create Variant"}
                                                </Button>
                                            </Modal.Footer>
                                        </Form>
                                    </Modal>
                                    {/* Add varient */}

                                    <Modal show={showVariantSpecification} onHide={handleSpecificationClose} centered className='modal_create' size='lg' backdrop="static">
                                        <Modal.Header closeButton>
                                            <Modal.Title>Add Specification</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className='modal_content_wrapper'>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Add Specification</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        onChange={(e) => setVariantSpecificChange(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button className='cancle_btn' onClick={handleSpecificationClose}>Cancel</Button>
                                            <Button className='submit_btn' onClick={handleVairantSpecificSubmit}>Submit</Button>
                                        </Modal.Footer>
                                    </Modal>

                                </div>
                            </div>
                        </div>

                    </div >
                </div >

            )}

        </>
    )
}

export default CreateInventory